const en = {
    pageHeader: {
        pageHeader: {
            mobileHeader: {
                index: 'Home',
                product: 'Products',
                cpuProduct: 'Processor',
                ipProduct: 'Core IP',
                developer: 'Developers',
                aboutRivai: 'About RiVAI',
                joinRivai: 'Careers',
            },
            "cooperate": "Cooperation",
            "download": "Downloads"
        }
    },
    pageFooter: {
        wx: 'Wechat',
        founderProfile: 'Founder',
        invest: 'Investors',
        processorProduct: 'Processor',
        ipProduct: 'Core IP',
        slogan: 'RiVAI provides microprocessor cores based on the open RISC-V technology targeting specifically the high-end and emerging markets.',
        cooperate: 'Cooperate',
        mondayFriday: 'Monday to Friday',
        copyRight: 'Copyright © 2018 - 2025 RiVAI Technologies (Shenzhen) Co., Ltd. All rights reserved.',
        number1: 'Guangdong ICP No. 18130670 -1',
        number2: 'YGPANB No. 44030502003396',
        btnList: {
            env: {
                ecology: 'Ecology',
                partner: 'Partner',
                product: 'Product',
            },
            product: {
                title: 'Products',
                lingyuCpu: 'Lingyu processor',
                products: 'IPs products',
            },
            aboutRivai: {
                title: 'About RiVAI',
                introduce: "Company Profile",
                devProgress: "History",
                honor: "Honor and Awards",
                contact: "Contact Us",
                join: "Join Us",
                wechat: "Wechat"
            },
            joinRivai: {
                title: 'Careers',
                recruit: 'Jobs'
            },
            followUs: {
                follow: 'Follow',
            }
        }
    },
    bodyOverview: {
        bodyOverview: {
            rivai: 'RiVAI',
            rivaiHPApp: 'Enabling high-performance applications',
            rivaiDescText: 'Focusing on intelligent computing power needs and data center scenarios, provide global customers with flexible supply chain options',
            more: 'More',
            joinUs: 'join Us',
            aboutUs: 'About Us',
            knowMoreInfo: 'Know more info',
            aboutUsDes: 'Founded in 2018, RiVAI is one of the earliest companies in China to design RISC-V high-end processors. The founding team came from the original RISC-V project team of UC, Berkeley, and brought together high-level talents in micro-architecture design and chip productization at home and abroad.',
            newsTitle: 'News',
            newsTitleDes: 'The latest news and information about RiVAI',
            p600: 'High Efficiency RISC-V Processor for Edge Computing',
            data_center: 'Storage',
            audio: 'Audio',
            image: 'Image',
            video: 'Video',
            Industrial: 'Industry',
            network: 'Network',
            communication: 'Communication',
            btn: 'Watch conference',
            productList: {
                btnDes: 'Learn More',
                cpuLingyu: 'Lingyu Processor'
            },
            message: {
                title: '',
                content: 'Dr. Zhangxi Tan is a graduate of Tsinghua University and holds a Ph.D. from the University of California, Berkeley, specializing in computer architecture and VLSI.  He is a student of Prof. David Patterson, the creator of RISC and the winner of the 2017 Turing Award.  Dr. Tan is Prof. Patterson\'s first and only Ph.D. student from mainland China.',
                des: 'Founder'
            }
        }
    },
    bodyAbout: {
        cooperate: "Business Cooperation",
        aboutRivai: 'About RiVAI',
        bodyAbout: {
            investmentEndorsement: {
                title: 'Backed by Leading Investors',
                info: 'Since its establishment, RiVAI has been endorsed by many top investment institutions'
            },
            founderProfile: 'Founder',
            slogan: "",
            buttonNames1: "Company Profile",
            buttonNames2: "Development Path",
            buttonNames4: "Honors and Awards",
            aboutus: "About Us",
            rewards: "Honors and Awards",
            rewardslower: "Continuous improvement, award-winning gold team",
            viewofvaluepre: "Our culture that features a vitality of innovation prepared us to handle challenges and seize opportunities",
            viewofvalue: "Values",
            viewofvaluelower: "",
            contactus: "Contact Us",
            shenzhen: "Shenzhen",
            headquarter: "Headquarter",
            shenzhenaddresslast: "Qianhai Shenzhen-Hong Kong Cooperation Zone, Shenzhen",
            chengdu: "Chengdu",
            subcompany: "Subsidiary",
            hongkong: 'Hong Kong',
            hongkongAddr: 'Hong Kong Science Park, New Territories, Hong Kong',
            chengduaddresslast: "Chengdu High-tech Zone, Sichuan Province",
            infocowork: "Business Cooperation",
            inforecruit: "Resume delivery",
            infotel: "Telephone",
            recruit: "Join RiVAI",
            recruitslogan: "Together, and change the world",
            recruitlinkto: "Find your perfect role ",
            recruitgrow: "Grow into",
            recruitgrowContent: "Challenging and influential work content, cutting-edge knowledge and technology, working with top chip engineers, leading you to discover more possibilities.",
            recruitlive: "RiVAI life",
            recruitliveContent: "Sound employee social insurance and medical security, diverse health care, rich team building activities, happy work and healthy life.",
            recruitdev: "Development",
            recruitdevContent: "Targeted training, a competitive salary and promotion opportunities, empowering personal development in all aspects",
            recruittollerance: "Inclusion",
            recruittolleranceContent: "Free and inclusive cultural atmosphere, efficient and open office environment, flexible and flexible working mechanism, efficiency first, result orientation.",

            aboutT1: 'RiVAI was founded by Dr. Tan Zhangxi in 2018, ',
            aboutT2: 'It is one of the earliest companies in China to design RISC-V high-end processors. Founding Team',
            aboutT3: 'from the original RISC-V project team at the University of California, Berkeley,',
            aboutT4: 'bringing together high-level talents in micro-architecture design and chip productization from home and abroad.',
            aboutT5: 'The team is committed to building a new generation of cloud-native CPUs to enable high-performance application scenarios such as cloud computing, cloud storage, and 5G/6G networks, focusing on intelligent computing power needs and data center scenarios.',
            aboutT6: 'Cooperate with business and ecosystem partners to promote the development of cloud-native CPUs, provide global customers with flexible supply chain options for core technologies, ',
            aboutT7: 'and build and promote the prosperity of the RISC-V ecosystem'
        },
        devProgress: {
            growthExp: "Development History",
            growthExpLower: "Follow the trend and respond proactively",

            process1: {
                name: "2023",
                items: [{
                    time: "Mar",
                    content: "Received tens of millions of yuan in strategic financing from Sichuan Venture Capital; Won the title of \"Specialized, Refined and New Enterprise\" in Shenzhen"
                }
                ]
            },
            process2: {
                name: "2022",
                items: [{
                    time: "May",
                    content: "Won the \"Top 10 Best Investment Cases in China's Semiconductor and Integrated Circuit Industry in 2021\" by ChinaVenture.com”"
                },
                    {
                        time: "Jun",
                        content: "Release of high-computing RISC-V vector processor"
                    },
                    {
                        time: "Dec",
                        content: "Released the edge computing processor RiVAI P600; obtained national high-tech enterprise certification"
                    }
                ]
            },
            process3: {
                name: "2021",
                items: [{
                    time: "Jan",
                    content: "Established strategic partnerships with top global semiconductor companies to implement commercialized edge applications"
                },
                    {
                        time: "Sep",
                        content: "Completed series A+ financing, led by ByteDance and Hillhouse Ventures, followed by other internationally-known institutions; established strategic partnerships with world's leading communication service providers for planning for high-end processors."
                    },
                    {
                        time: "Dec",
                        content: "Established strategic partnerships with Lenovo in cloud notebook."
                    }
                ]
            },
            process4: {
                name: "2020",
                items: [{
                    time: "Jul",
                    content: "Successfully tape out 32-bit chip."
                },
                    {
                        time: "Oct",
                        content: "Won the excellence award of the enterprise group in the electronic information industry final of the 12th China Shenzhen Innovation and Entrepreneurship Competition."
                    },
                    {
                        time: "Dec",
                        content: "Successfully tape out 64-bit chip."
                    }
                ]
            },
            process5: {
                name: "2019",
                items: [{
                    time: "Jan",
                    content: "RiVAI's chip received award of advanced chip by China RISC-V Alliance (CRVIC)."
                },
                    {
                        time: "Mar",
                        content: "Completed series A financing, followed by Northern Lights and Innovation DreamWorks."
                    },
                    {
                        time: "Jul",
                        content: "Awarded best product development by Leiphone."
                    }
                ]
            },
            process6: {
                name: "2018",
                items: [{
                    time: "Aug",
                    content: "Founded in Shenzhen."
                },
                    {
                        time: "Nov",
                        content: "Released risc-v-based 64-bit programmable chip."
                    }
                ]
            },
        },
        managerTeam: {
            tanboInto: "Dr. Tan graduated from Tsinghua University and earned his Ph.D. from the University of California, Berkeley, where he studied under Turing Award laureate Professor David Patterson. During his time at Berkeley, he played a key role in the early development and advocacy of RISC-V.",
            tanboMore: "More",
            tanboMoreName: "Dr. Zhangxi Tan",
            tanboMoreTitle: "Founder, Chairman of the Board, CEO",
        },
        tanboDetail1: 'Dr. Zhangxi Tan received his B.Eng. and M.Eng. in Electronic Engineering from Tsinghua University, and went on to earn a Ph.D. in Computer Science at UC Berkeley under 2017 Turing Award laureate Prof. David Patterson. During his doctoral studies, he was directly involved in the original development and early promotion of the RISC-V instruction-set architecture.',
        tanboDetail2: 'Upon completing his Ph.D., Dr. Tan joined Pure Storage (NYSE: PSTG) as a founding engineer and the company’s inaugural chip designer, where he led the FlashBlade project—recipient of the 2017 AIconics Award for Best Hardware Innovation. In 2017, he founded OURS Technologies, an autonomous-driving semiconductor venture later acquired by Aurora Innovation (NASDAQ: AUR). A recognized authority in microprocessor design, flash-memory systems, and hardware accelerators, he holds numerous patents. In 2018, Dr. Tan established RiVAI Technologies to commercialize high-performance, cloud-native RISC-V microprocessor solutions.'
    },
    recruitPage: {
        recruitList: {
            all: "All",
            shenzheng: "Shenzhen",
            chengdu: "Chengdu"
        },
        recuitDetail: {
            apply: "Apply now",
            copy: "career@rivai.ai | Copy to clipboard",
            copy_success: "Copy successfully",
            copy_failed: "Copy failed",
        }
    },
    product: {
        unknownError: 'Unknow error',
        cannotBeNull: 'Cannot be null',
        invalidEmail: 'Invalid email',
        plzFillInfo: 'Please fill the form',
        contactValidate: 'Contact verification',
        plzInputForm: 'Please fill the information to access product information',
        validMsg: 'Information verification',
        finishValid: 'Complete verification',
        name: 'Name',
        company: 'Company',
        usage: 'Usage',
        usage1: 'Engineering & R&D',
        usage2: 'Business & Procurement',
        usage3: 'Academics & Education',
        usage4: 'Media & Reports',
        usage5: 'Others',
        tel: 'Tel',
        email: 'Email',
        msgUseInConsult: 'Your information is only used for product consultation and service support',
        cancel: 'Cancel',
        submit: 'Submit',
        validSuccess: 'Verification successful!',
        moreConsult: 'Please consult us for more product information!',
        enterDownload: 'Download Center',
        cooperateConsult: 'Cooperation consult',
        bizCooperate: 'Business cooperation or product consult',
        contentConsult: 'Consultation content',
        finishSubmit: 'Complete submit',
        cooperateIntent: 'Cooperation intention or consultation content',
        iRead: 'I have read and agree',
        rivaiPrivate: 'RiVAI Privacy Policy',
        sendEmail: 'Or send to mailbox',
        submitSuccess: 'Submission successful!',
        asaContact: 'We will contact you as soon as possible and look forward to cooperating with you!',
        back: 'Back',
        docDownload: 'Downloads',
        knowMoreFurther: 'For more information about this product',
        disagreePrivate: 'You have not yet agreed to RiVAI\'s Privacy Policy',
        close: 'Close',
        downloadCenter: 'Download Center',
        downloadProduct: 'Download product information to help technology development',
    }
}
export default en;